import { useQueryCashed } from "@/hooks/useQueryCashed";

import { GetLeftInfoApi } from "../GetLeftInfo.api";

export const useLeftBarData = () => {
  return useQueryCashed({
    queryKey: ["LEFTBAR_DATA"],
    queryFn: async () => {
      return GetLeftInfoApi.getLeftInfo();
    },
  });
};
